function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { Controller } from "react-hook-form";
import FileUploadInput from "../../components/FileUploadInput/FileUploadInput";
const FileUploadField = ({
  isError,
  useFormProps,
  field,
  formId,
  sectionId,
  rowId,
  columnId,
  sectionValueId,
  formSubmitSucceeded,
  uploadFileUrl,
  text,
  elementId,
  wuiltContext
}) => {
  return /*#__PURE__*/React.createElement(Controller, {
    control: useFormProps?.control,
    name: field?.id,
    render: ({
      field: fieldProps
    }) => /*#__PURE__*/React.createElement(FileUploadInput, _extends({
      formId: formId,
      sectionId: sectionId,
      rowId: rowId,
      columnId: columnId,
      formSubmitSucceeded: formSubmitSucceeded,
      sectionValueId: sectionValueId,
      uploadFileUrl: uploadFileUrl,
      isError: isError,
      id: field?.id,
      fieldSettings: field?.settings || {}
    }, fieldProps, {
      text: text,
      elementId: elementId,
      wuiltContext: wuiltContext
    }))
  });
};
export default FileUploadField;
//# sourceMappingURL=FileUploadField.js.map